import { ACTION_TYPES } from '../../utils/Constants';
let intialState = {
    previousSession: [],
    todaySession: [],
    upcomingSession: [],
    manageSchedule: [],
    waitingRoom: [],
    onDemandCount: '',
    appointmentCount: '',
    physicianShowTimer: false,
    patientShowTimer: false,
};

const DashBoardReducer = (state = intialState, action = {}) => {
    switch (action.type) {
        case ACTION_TYPES.PHYSICIAN.DASHBOARD:
            state = {
                ...state,
                previousSession: action.payload.previousSession,
                manageSchedule: action.payload.manageSchedule,
                upcomingSession: action.payload.upcomingSession,
            };
            break;
        case ACTION_TYPES.PHYSICIAN.DASHBOARD_APPOINTMENT:
            return {
                ...state,
                todaySession: action.payload,
            };
        case ACTION_TYPES.PHYSICIAN.SHOWTIMER:
            state = {
                ...state,
                physicianShowTimer: action.payload,
            };
            break;
        case ACTION_TYPES.PATIENT.SHOWTIMER:
            state = {
                ...state,
                patientShowTimer: action.payload,
            };
            break;
        case ACTION_TYPES.PHYSICIAN.UPDATE_WATING_ROOM_SOCKET_SUCESS:
            return {
                ...state,
                waitingRoom: action.payload.waitingRoom,
            };
        case ACTION_TYPES.PHYSICIAN.ONDEMAND_BOOKING_CONFIRMATION:
            return {
                ...state,
                onDemandCount: action.payload.waitingRoomCount,
            };
        case ACTION_TYPES.PHYSICIAN.APPOINTMENT_BOOKING_CONFIRMATION:
            return {
                ...state,
                appointmentCount: action.payload.waitingRoomCount,
            };
        default:
            break;
    }
    return state;
};
export default DashBoardReducer;
